import React, { Component } from 'react';

class VoiceflowChat extends Component {
  componentDidMount() {
    // Load Voiceflow chat widget
    (function (d, t) {
      var v = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
      v.onload = function () {
        if (window.voiceflow && window.voiceflow.chat) {
          if (window.voiceflow.chat.load) {
            window.voiceflow.chat.load({
              verify: { projectID: '65c3ce30bc03442887824b21' },
              url: 'https://general-runtime.voiceflow.com',
              versionID: 'production',
            });
          } else {
            console.error('Voiceflow chat "load" method not found.');
          }
        } else {
          console.error('Voiceflow chat object or methods not found.');
        }
      };
      v.src = 'https://cdn.voiceflow.com/widget/bundle.mjs';
      v.type = 'text/javascript';
      s.parentNode.insertBefore(v, s);
    })(document, 'script');
  }

  render() {
    return (
      <div style={styles.container}>
        <h2 style={styles.heading}>Voiceflow Chat</h2>
        <p style={styles.paragraph}>
          Use the blue widget to interact. Simply click on it and follow the prompts to engage with the Voiceflow assistant.
        </p>
      </div>
    );
  }
}

const styles = {
  container: {
    maxWidth: '80%', // Adjust as needed
    margin: 'auto',
    textAlign: 'center',
  },
  heading: {
    color: '#2e7ff1',
    fontSize: '1.5em', // Adjust as needed
  },
  paragraph: {
    color: '#2e7ff1',
    fontSize: '1em', // Adjust as needed
  },
};

export default VoiceflowChat;










